import type { TypeOrArray } from '../../../../common-interfaces';
import type { JsonDataItem } from '../../../../generic-types';
import type { VisibilityCondition } from '../../visibility-condition.interfaces';
import type { ITargetValueConverter, ValueConverterReturnType } from './i-target-value-converter';

export class NumberTargetValueConverter implements ITargetValueConverter {
  convert(condition: VisibilityCondition, data: JsonDataItem): TypeOrArray<ValueConverterReturnType> {
    if (condition.sourceFieldId && data?.[condition.sourceFieldId]) {
      const dataItem = data[condition.sourceFieldId];
      if (Array.isArray(dataItem)) {
        const wrapperArray: Array<ValueConverterReturnType> = [];

        for (let i = 0, length = dataItem.length; i < length; i++) {
          wrapperArray.push([
            Number(dataItem[i]),
            Number(condition.targetValue),
            condition.negation || false,
            condition.filterOperator || 'EQUALS',
          ]);
        }

        return wrapperArray.length > 0
          ? wrapperArray
          : [
              undefined,
              Number(condition.targetValue),
              condition.negation || false,
              condition.filterOperator || 'EQUALS',
            ];
      } else {
        return [
          Number(dataItem),
          Number(condition.targetValue),
          condition.negation || false,
          condition.filterOperator || 'EQUALS',
        ];
      }
    }

    return [
      undefined,
      Number(condition.targetValue),
      condition.negation || false,
      condition.filterOperator || 'EQUALS',
    ];
  }
}
